import React, { useState, useEffect } from "react";
import { createModel } from "hox";
import useStorageState from "@/hooks/useStorageState";
import { globalPrompt } from "@/components/message";
import { dictService, IDictDetail, IDictSearch } from "./assetsAskService";
import { defaultMdCmParam } from "@/utils/constants";
import { message } from "antd";
import { useOrgModel } from "../organization/orgModel";

type dictObj = {
    [key: string]: any
}

export type ITreeSelectData = {
    title: string,
    value: string,
    selectable?: boolean,
    children: ITreeSelectData[]
}

function treeChangeList(list: any) {
    let res: any = []
    flatten(list)
    function flatten(list) {
        for (let i = 0; i < list.length; i++) {
            if (list[i].children.length > 0) {
                const { children, ...newChild } = list[i]
                res.push({ ...newChild, children: [] })
                flatten(children)
            } else {
                res.push(list[i])
            }
        }
    }
    return res
}

export const useDictModel = createModel(function () {
    const { sourceApp, branch } = defaultMdCmParam;
    const [treeSource, setTreeSource, clearTreeSource] = useStorageState<IDictDetail[]>("dictTree", []);  //字典数据源
    const [originDictList, setOriginDictList, clearOriginDictList] = useStorageState<IDictDetail[]>("dictList", []);  //字典数据源
    const [selectedNodes, setSelectedNodes] = useState<IDictDetail[]>([]);  //树选中的行信息
    const [mode, setMode] = useState<"add" | "look">("add");  //模式
    const [formVal, setFormVal] = useState<any>(selectedNodes[0]);  //表单缓存
    const [getOneNameList, setGetOneNameList] = useState<any>([]);  //单条查询name
    const [getOneData, setGetOneData] = useState<any>({});  //单条查询name
    const [addUserVisible, setAddUserVisible] = useState<boolean>(false);  //单条查询name
    const [addUserData, setAddUserData] = useState<any>({});  //单条查询name
    const [editUserData, setEditUserData] = useState<any>({});  //单条查询name
    const [detialSelect, setDetialSelect] = useState<any>([]);  //选择默认值
    const [allNameList, setAllNameList] = useState<any>([]);  //选择默认值
    const { treeSource: orgTreeSource, loadData: orgLoadData, setSelectedNodes: setorgSelectedNodes, selectedNodes: orgSelectedNodes, } = useOrgModel();

    //实时缓存
    const onChangeFormVal = (changedValues: { [key: string]: any }) => {
        setFormVal({ ...formVal, ...changedValues });
    }

    useEffect(() => {
        if (mode === "add" && selectedNodes[0]) {
            let newName = getOneNameList.length > 0 ? getOneNameList[0] + '-' + `${getOneNameList.length + 1}` : '';
            setFormVal({
                name: newName,
                typeName: selectedNodes[0].name,
                typeCode: selectedNodes[0].code,
                user: '',
                userCode: '',
                department: '',
                departmentName: '',
                status: 1
            })
        }
        else if (mode === "look" && selectedNodes[0]) {
            getOne(selectedNodes[0].code)
        }
    }, [mode, selectedNodes[0]])
    //单条查询
    const getOne = async (value) => {
        let data = {
            typeCode: value,
            unit: orgSelectedNodes[0].code ?? '',
        }
        let { retData } = await dictService.getOne(data);
        setGetOneNameList(Object.keys(retData))
        setGetOneData(retData)
        let newList: any = []
        let nameList: any = []
        Object.keys(retData).map((item) => {
            if (retData[item][0].status) {
                newList.push(item)
            }
            retData[item].map((list) => {
                nameList.push(list.userCode)
            })
        })
        setAllNameList(nameList)
        setDetialSelect(newList)
    }
    //字典列表请求
    const loadData = async () => {
        let data: IDictSearch = {
            sourceApp,
            page: {
                pageSize: -1,
                pageNum: 1,
            },
            branch: 'assets',
            code: 'assets-apply-type'
        }
        let { retData } = await dictService.page(data);
        setTreeSource(retData[0].children);
        setOriginDictList(treeChangeList(retData[0].children));
        setSelectedNodes([])
    }


    //表单提交
    const onSubmit = async (value) => {
        if (allNameList.includes(formVal?.userCode)) {
            globalPrompt("message", { text: "不可选择重复联系人！", type: "warning" });
            return;
        }
        let data = {
            name: editUserData.name ?? addUserData.name ?? formVal?.name,
            typeCode: editUserData.typeCode ?? addUserData.typeCode ?? selectedNodes[0]?.code,
            typeName: editUserData.typeName ?? addUserData.typeName ?? selectedNodes[0]?.name,
            user: formVal?.user,
            userCode: formVal?.userCode,
            department: formVal?.department,
            departmentName: formVal?.departmentName,
            status: 1,
            unit: orgSelectedNodes[0].code,
            unitName: orgSelectedNodes[0].name
        }

        if (!data.user || !data.name) {
            globalPrompt("message", { text: "请检查必填项", type: "warning" });
            return;
        }
        if (getOneNameList.includes(editUserData.name)) {
            let { retData } = await dictService.update({ ...data, id: editUserData.id });
            retData && globalPrompt("message", { type: "success", text: "审批人修改成功！" });
        } else {
            let { retData } = await dictService.insert(data);
            retData && globalPrompt("message", { type: "success", text: "审批人添加成功！" });
        }

        if (value == 'add') {
            setFormVal({
                name: '',
                typeName: selectedNodes[0].name,
                typeCode: selectedNodes[0].code,
                user: '',
                userCode: '',
                department: '',
                departmentName: '',
                status: 1,
                unit: orgSelectedNodes[0].code,
                unitName: orgSelectedNodes[0].name
            })
            message.success('添加申请配置')
        }
        else if (value == 'finish') {
            setMode('look')
        }
        else if (value == 'addUser') {
            getOne(selectedNodes[0].code)
            setAddUserData({})
            setEditUserData({})
            setAddUserVisible(false)
        }
        // loadData();
        // setSelectedNodes([]);
    }

    return {
        /***field***/
        treeSource,
        selectedNodes,
        mode,
        formVal,
        getOneData,
        getOneNameList,
        addUserVisible,
        addUserData,
        detialSelect,
        editUserData,
        /***method***/
        setDetialSelect,
        setAddUserData,
        setAddUserVisible,
        setGetOneNameList,
        setGetOneData,
        setTreeSource,
        setSelectedNodes,
        setMode,
        setFormVal,
        onChangeFormVal,
        loadData,
        onSubmit,
        getOne,
        setEditUserData
    }
});